import { register } from 'swiper/element/bundle';
register();

require('./a11y.js')
require('./carousel.js')
require('./navbar.js')
require('./navSidebar.js')
require('./images.js')
require('./modal.js')
require('./ux.js')
require('./mailchimp.js')
require('./events/app.js')
require('./transparencyReport.js')
require('./notifications/app.js')
require('./calendarFeed/app.js')
require('./staffDirectory/app.js')
